var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import Select from "react-select";
import { ReactSelectCustomComponents, useReactSelectQuinineClassnames } from "./react-select.js";
/** An uncontrolled select dropdown. This component uses [React Select](https://react-select.com) under the hood, so refer to their documentation to get a full understanding of everything this component can do. */
export function QuiSelect(_a) {
    var { size, disabled, placement, invalid, options, id, onOpen, onClose } = _a, otherProps = __rest(_a, ["size", "disabled", "placement", "invalid", "options", "id", "onOpen", "onClose"]);
    const reactSelectClassNames = useReactSelectQuinineClassnames({ size, invalid });
    return (React.createElement(Select, Object.assign({ options: options, size: size }, otherProps, { isDisabled: disabled, components: ReactSelectCustomComponents, unstyled: true, classNames: reactSelectClassNames, inputId: id, menuPlacement: placement !== null && placement !== void 0 ? placement : "auto", onMenuOpen: onOpen, onMenuClose: onClose })));
}
